// Color por status de ConsultationPayment — usado en los chips de "monto a
// cobrar" de la sala de espera y la agenda del día (ver WaitingRoom.js,
// RecepcionistDashboard.js). El label completo ya viene armado del backend
// (ej. "Seña $5.000"), acá solo se necesita el color.
export const PAYMENT_STATUS_COLOR = {
  pendiente: 'warning',
  'seña': 'secondary',
  pagado: 'success',
  obra_social: 'info',
  exento: 'default',
};
